var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"layout-panel"},_vm._l((_vm.portfolioEntries),function(entry){return _c('PortfolioSingle',_vm._b({key:entry.url},'PortfolioSingle',entry,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }